import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import VirtualEnergySummaryCards from "../../components/VirtualSummaryCards";
import VirtualWeeklyActiveChart from "../../components/VirtualWeeklyActiveChart";
import VirtualWeeklyReactiveChart from "../../components/VirtualWeeklyReactiveChart";

import VirtualActiveEnergyPie from "../../components/VirtualActiveEnergyPie";
import VirtualReactiveEnergyPie from "../../components/VirtualReactiveEnergyPie";

export default function VirtualEnergyDashboard() {
    const { virtualId } = useParams();
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [summary, setSummary] = useState({
        P_IMPORT: 0,
        P_EXPORT: 0,
        Q_IMPORT: 0,
        Q_EXPORT: 0,
    });

    // --- SUMMARY ---
    useEffect(() => {
        async function load() {
            try {
                const [impAct, expAct, impReac, expReac] = await Promise.all([
                    fetch(`${API_BASE}/virtual/${virtualId}/import-active`).then(r => r.json()),
                    fetch(`${API_BASE}/virtual/${virtualId}/export-active`).then(r => r.json()),
                    fetch(`${API_BASE}/virtual/${virtualId}/import-reactive`).then(r => r.json()),
                    fetch(`${API_BASE}/virtual/${virtualId}/export-reactive`).then(r => r.json()),
                ]);

                setSummary({
                    P_IMPORT: impAct.P_IMPORT_ENERGY || 0,
                    P_EXPORT: expAct.P_EXPORT_ENERGY || 0,
                    Q_IMPORT: impReac.Q_IMPORT_ENERGY || 0,
                    Q_EXPORT: expReac.Q_EXPORT_ENERGY || 0,
                });
            } catch (err) {
                console.error("Virtual summary error:", err);
            }
        }

        load();
    }, [virtualId, API_BASE]);

    return (
        <div className="p-6 space-y-10">

            {/* 1️⃣ Summary Cards */}
            <VirtualEnergySummaryCards data={summary} />

            {/* 2️⃣ Son 7 Günlük Aktif & Reaktif */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <VirtualWeeklyActiveChart virtualId={virtualId} API_BASE={API_BASE} />
                <VirtualWeeklyReactiveChart virtualId={virtualId} API_BASE={API_BASE} />
            </div>

            {/* 3️⃣ Aktif + Reaktif Pie Chartlar */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <VirtualActiveEnergyPie
                    importVal={summary.P_IMPORT}
                    exportVal={summary.P_EXPORT}
                />

                <VirtualReactiveEnergyPie
                    importVal={summary.Q_IMPORT}
                    exportVal={summary.Q_EXPORT}
                />
            </div>

        </div>
    );
}
